<div class="main">
    <div *ngIf="showLoader" class="loader">
        <div class="load">
          <mat-spinner></mat-spinner>
        </div>
    </div>
    <div class="section">
        <div class="sectionHeader">
            <div class="header">
            <div class="title">
                <div class="label">
                    {{'CREATE_BILLS.title' | translate}}
                </div>
                <div class="help">
                    <!-- <app-help [helpData]="helpData" ></app-help> -->
                </div>
                </div>
                
            </div>
        </div>
        <div class="status">
            <div class="view">
                <div class="liveStatus">
                    <div class="title">
                        {{'CREATE_BILLS.status' | translate}}
                    </div>
                    <div class="row">
                        <div class="card" [ngClass]="{'green green-selected': selectStatusArray.approved, 'green': !selectStatusArray.approved}" (click)="disableSelectAll = false; selectInvoiceStatus('APPROVED','approved')">
                            <div class="label" [ngClass]="{'selectedLabel': selectStatusArray.approved}">
                                {{'CREATE_BILLS.approved' | translate}}
                            </div>
                            <div class="content" [ngClass]="{'selectedContent': selectStatusArray.approved}">
                                <mat-spinner *ngIf="status_data.approved.loader" [diameter]="20"></mat-spinner>
                                <span *ngIf="!status_data.approved.loader">{{ status_data.approved.value }}</span>
                            </div>
                        </div>
                        <div class="card" [ngClass]="{'red red-selected': selectStatusArray.disapproved, 'red': !selectStatusArray.disapproved}" (click)="disableSelectAll = true;selectInvoiceStatus('DISAPPROVED','disapproved')">
                            <div class="label" [ngClass]="{'selectedLabel': selectStatusArray.disapproved}">
                                {{'CREATE_BILLS.disapproved' | translate}}
                            </div>
                            <div class="content" [ngClass]="{'selectedContent': selectStatusArray.disapproved}">
                                <mat-spinner *ngIf="status_data.disapproved.loader" [diameter]="20"></mat-spinner>
                                <span *ngIf="!status_data.disapproved.loader">{{ status_data.disapproved.value }}</span>
                            </div>
                        </div>
                        <div class="card" [ngClass]="{'orange orange-selected': selectStatusArray.pending, 'orange': !selectStatusArray.pending}"  (click)="disableSelectAll = true;selectInvoiceStatus('PENDING', 'pending')">
                            <div class="label" [ngClass]="{'selectedLabel': selectStatusArray.pending}">
                                {{'CREATE_BILLS.pending' | translate}}
                            </div>
                            <div class="content" [ngClass]="{'selectedContent': selectStatusArray.pending}">
                                <mat-spinner *ngIf="status_data.pending.loader" [diameter]="20"></mat-spinner>
                                <span *ngIf="!status_data.pending.loader">{{ status_data.pending.value }}</span>
                            </div>
                        </div>
                        <div class="card" [ngClass]="{'blue blue-selected': selectStatusArray.billed, 'blue': !selectStatusArray.billed}" (click)="disableSelectAll = true;selectInvoiceStatus('BILLED','billed')">
                            <div class="label" [ngClass]="{'selectedLabel': selectStatusArray.billed}">
                                {{'CREATE_BILLS.billed' | translate}}
                            </div>
                            <div class="content" [ngClass]="{'selectedContent': selectStatusArray.billed}">
                                <mat-spinner *ngIf="status_data.billed.loader" [diameter]="20"></mat-spinner>
                                <span *ngIf="!status_data.billed.loader">{{ status_data.billed.value }}</span>
                            </div>
                        </div>
                        <div class="card" [ngClass]="{'yellow yellow-selected': selectStatusArray.no_of_ready_for_payment, 'yellow': !selectStatusArray.no_of_ready_for_payment}"  (click)="disableSelectAll = true;selectInvoiceStatus('READY_FOR_PAYMENT', 'no_of_ready_for_payment')">
                            <div class="label" [ngClass]="{'selectedLabel': selectStatusArray.no_of_ready_for_payment}">
                                {{'CREATE_BILLS.no_of_ready_for_payment' | translate}}
                            </div>
                            <div class="content" [ngClass]="{'selectedContent': selectStatusArray.no_of_ready_for_payment}">
                                <mat-spinner *ngIf="status_data.no_of_ready_for_payment.loader" [diameter]="20"></mat-spinner>
                                <span *ngIf="!status_data.no_of_ready_for_payment.loader">{{ status_data.no_of_ready_for_payment.value }}</span>
                            </div>
                        </div>

                        <div class="card" [ngClass]="{'pink pink-selected': selectStatusArray.no_of_payment_paid, 'pink': !selectStatusArray.no_of_payment_paid}"  (click)="disableSelectAll = true;selectInvoiceStatus('PAYMENT_PAID', 'no_of_payment_paid')">
                            <div class="label" [ngClass]="{'selectedLabel': selectStatusArray.no_of_payment_paid}">
                                {{'CREATE_BILLS.no_of_payment_paid' | translate}}
                            </div>
                            <div class="content" [ngClass]="{'selectedContent': selectStatusArray.no_of_payment_paid}">
                                <mat-spinner *ngIf="status_data.no_of_payment_paid.loader" [diameter]="20"></mat-spinner>
                                <span *ngIf="!status_data.no_of_payment_paid.loader">{{ status_data.no_of_payment_paid.value }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="generated-invoice">
            <div class="invoice-title">
                {{'CREATE_BILLS.generated_invoice' | translate}} - {{showStatus}} {{'CREATE_BILLS.invoices' | translate}}
            </div>
            
            <div class="buttons">
                <!-- <div  [ngClass]="{'disable-btn': !enableCreateBillButton || !invoiceFilters.shipper, 'button':  enableCreateBillButton && invoiceFilters.shipper }" (click)=" (enableCreateBillButton && invoiceFilters.shipper) ? bulkGenerate() : '' ">{{'CREATE_BILLS.bulk_generate_bill' | translate}}</div>
                -->
                <div  [ngClass]="{'disable-btn': !enableCreateBillButton, 'button':  enableCreateBillButton}" (click)=" (enableCreateBillButton && (invoiceFilters.shipper  || this.shippersArray[0].parent_name == 'All')) ? bulkGenerate() : '' ">{{'CREATE_BILLS.bulk_generate_bill' | translate}}</div>
                <div class="button" style="width: auto;" (click)="openShipmentDashboard($event,'p_invoices')">{{'CREATE_BILLS.list_shipments' | translate}}</div>
                <div class="button" style="width: auto;" (click)="clearFilter()">{{'CREATE_BILLS.clear_filter' | translate}}</div>
            </div>
        </div>

        <div class="filter">
            <div class="container">
            <div class="select-shipper">
                <div class="title">
                        {{'CREATE_BILLS.enterprise_unit_name' | translate}}
                </div>
                <mat-select class="inputSelect" [(ngModel)]="selectedShipper">
                    <mat-option *ngFor="let shipper of shippersArray" [value]="shipper" (click)="selectShipper(shipper)">
                        {{shipper.parent_name}} <span *ngIf="shipper.name">- {{shipper.name}}</span>
                    </mat-option>
                </mat-select>
            </div>
            <div class="transit-type" *ngIf="showTransitType" >
                <div class="title">
                    {{'CREATE_BILLS.transit_type' | translate}}
                </div>
                <mat-select class="inputSelect" [(ngModel)]="selectedTransitType">
                    <mat-option *ngFor="let transit_type of transit_types" [value]="transit_type" (click)="selectTransitType(transit_type)">
                        {{transit_type.name}}
                    </mat-option>
                </mat-select>
            </div>
            <div class="search">
                <!-- <div class="inputSearch">
                    <input (keyup)="applyFilter($event.target.value)" placeholder=""  class="inputSelect">
                </div> -->
            </div>
            <div class="select-date">
                <div class="title">
                        {{'CREATE_BILLS.from' | translate}}    
                </div>
                <div >
                    <input type="text" class="dateSelect" [matDatepicker]="from_date"  [(ngModel)]="date_filter.from_date" [max]="date_filter.max" (click)="from_date.open()"/>
                    <mat-datepicker #from_date (closed)="setFromDateTime(date_filter)" [startAt]="date_filter.from_date"></mat-datepicker>
                    <i class="material-icons calendar">date_range</i>
                </div>
            </div>

            <div class="select-date">
                <div class="title">
                        {{'CREATE_BILLS.to' | translate}}    
                </div>
                <div >
                    <input type="text" class="dateSelect" [matDatepicker]="to_date" [(ngModel)]="date_filter.to_date" [min]="date_filter.min" (click)="to_date.open()"/>
                    <i class="material-icons icon calendar">date_range</i>
                    <mat-datepicker #to_date (closed)="setToDateTime(date_filter)" [startAt]="date_filter.to_date" ></mat-datepicker>
                </div>
            </div>
         </div>
        </div>
        <div class="table" >
            <table mat-table class="mat-elevation-z8" #table [dataSource]="invoicesList.filteredData" *ngIf="invoicesList && invoicesList.filteredData.length;else noInvoices ">
                    <ng-container matColumnDef="include">
                            <th mat-header-cell *matHeaderCellDef>
                                <mat-checkbox [disabled]="disableSelectAll || !selectedShipper.id" (click)="$event.stopPropagation();" (change)="selectAll($event)" [checked]="select_all"></mat-checkbox>
                            </th>
                            <td mat-cell *matCellDef="let element">
                                    <mat-checkbox  (click)="$event.stopPropagation();" (change)="include($event,element)" [checked]="element.include"></mat-checkbox>
                            </td>
                    </ng-container>
                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef>
                            <!-- <div class="input">
                                <input type="text" [placeholder]="'CREATE_BILLS.invoice_id' | translate">
                            </div> -->
                            <div class="padding-5">
                                {{'CREATE_BILLS.invoice_id' | translate}}
                            </div>
                            <div class="padding-5">
                                {{'CREATE_BILLS.shipment_id' | translate}}
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <div class="padding-5"> 
                                <span class="links"  (click)="$event.stopPropagation();openInvoicePreview(element)">
                                    {{element.IINC}}
                                </span>
                                <!-- <a routerLink="preview" class="links"></a> -->
                            </div>
                            <div class="padding-5">
                                <span class="links"  (click)="$event.stopPropagation();openShipmentDetails(element)">
                                    {{element.SIN}}
                                </span>
                            </div>
                            <!-- <div class="pod-icon">
                                <img src="assets/POD1.svg" alt="" *ngIf="element.pod">
                                <img src="assets/POD2.svg" alt="" *ngIf="!element.pod">
                            </div> -->
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="enterprise_name">
                        <th mat-header-cell *matHeaderCellDef>
                            <!-- <div class="input">
                                <input type="text" placeholder="Bill Cycle">
                            </div> -->
                            {{'CREATE_BILLS.shipper' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element">{{element.enterprise_name}}</td>
                    </ng-container>

                    <ng-container matColumnDef="pickup_delivery">
                        <th mat-header-cell *matHeaderCellDef>
                            <!-- <div class="input">
                                <input type="text" placeholder="Bill Cycle">
                            </div> -->
                            {{'CREATE_BILLS.pickup_delivery' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <div class="locationDetails" *ngIf="!element.expand">
                                <mat-vertical-stepper selected="{{element.stepperIndex}}" [linear]="false" #stepper1>
                                    <mat-step [label]="locStep._id" [state]="locStep._id" *ngFor="let locStep of element.onlyPickupDrop;let i = index">
                                        <ng-template matStepLabel>{{locStep.location.name}}, {{locStep.location.city}}</ng-template>
                                    </mat-step>
                                    <ng-template  *ngFor="let locStep of element.pickups;let i = index"  [matStepperIcon]="locStep._id">
                                        <span class="pick-icon" style="font-size: 10px;">P{{i+1}}</span>
                                    </ng-template>
                                    <ng-template *ngFor="let locStep of element.deliveries;let i = index" [matStepperIcon]="locStep._id">
                                        <span class="drop-icon" style="font-size: 10px;">D{{i+1}}</span>
                                    </ng-template>
                                    </mat-vertical-stepper>
                            </div>
                            <div class="locationDetails" *ngIf="element.expand">
                                <mat-vertical-stepper selected="{{element.stepperIndex}}" [linear]="false" #stepper1>
                                    <mat-step [label]="locStep._id" [state]="locStep._id" *ngFor="let locStep of element.allLocationsData;let i = index">
                                        <ng-template matStepLabel>{{locStep.location.name}}, {{locStep.location.city}}</ng-template>
                                    </mat-step>
                                    <ng-template  *ngFor="let locStep of element.pickups;let i = index"  [matStepperIcon]="locStep._id">
                                        <span class="pick-icon" style="font-size: 10px;">P{{i+1}}</span>
                                    </ng-template>
                                    <ng-template *ngFor="let locStep of element.deliveries;let i = index" [matStepperIcon]="locStep._id">
                                        <span class="drop-icon" style="font-size: 10px;">D{{i+1}}</span>
                                    </ng-template>
                                    </mat-vertical-stepper>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="pickup_delivery_date">
                        <th mat-header-cell *matHeaderCellDef style="margin:0px 20px">
                            <!-- <div class="input">
                                <input type="text" placeholder="Bill Cycle">
                            </div> -->
                            {{'CREATE_BILLS.pickup_delivery_date' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <div class="locationDetails" *ngIf="!element.expand">
                                <mat-vertical-stepper selected="{{element.stepperIndex}}" [linear]="true" #stepper2>
                                    <mat-step [label]="locStep._id" [state]="locStep._id" *ngFor="let locStep of element.onlyPickupDrop;let i = index">
                                        <ng-template matStepLabel>
                                            {{ locStep.finished_at?timeService.toShortDateTime(locStep.finished_at): timeService.toShortDateTime(element.shipment.pickup_date) }}
                                        </ng-template>
                                    </mat-step>
                                    <ng-template  *ngFor="let locStep of element.pickups;let i = index"  [matStepperIcon]="locStep._id">
                                        <span class="pick-icon" style="font-size: 10px;">P{{i+1}}</span>
                                    </ng-template>
                                    <ng-template *ngFor="let locStep of element.deliveries;let i = index" [matStepperIcon]="locStep._id">
                                        <span class="drop-icon" style="font-size: 10px;">D{{i+1}}</span>
                                    </ng-template>
                                    </mat-vertical-stepper>
                            </div>
                            <div class="locationDetails" *ngIf="element.expand">
                                <mat-vertical-stepper selected="{{element.stepperIndex}}" [linear]="true" #stepper2>
                                    <mat-step [label]="locStep._id" [state]="locStep._id" *ngFor="let locStep of element.allLocationsData;let i = index">
                                        <ng-template matStepLabel>
                                            {{ locStep.finished_at ? timeService.toShortDateTime(locStep.finished_at): timeService.toShortDateTime(element.shipment.delivery_date) }}
                                        </ng-template>
                                    </mat-step>
                                    <ng-template  *ngFor="let locStep of element.pickups;let i = index"  [matStepperIcon]="locStep._id">
                                        <span class="pick-icon" style="font-size: 10px;">P{{i+1}}</span>
                                    </ng-template>
                                    <ng-template *ngFor="let locStep of element.deliveries;let i = index" [matStepperIcon]="locStep._id">
                                        <span class="drop-icon" style="font-size: 10px;">D{{i+1}}</span>
                                    </ng-template>
                                    </mat-vertical-stepper>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="status_date">
                        <th mat-header-cell *matHeaderCellDef>
                            <!-- <div class="input">
                                <input type="text" placeholder="Bill Cycle">
                            </div> -->
                            {{'CREATE_BILLS.status_date' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <div style="margin:5px 0px">
                                <span [ngClass]="{'approved': element.status == 'APPROVED','disapproved': element.status == 'DISAPPROVED','pending': element.status == 'PENDING','billed': element.status == 'BILLED'}">{{ element.status }}</span>
                            </div>
                            <div style="margin:5px 0px" class="bill-date">
                                {{element.approved_at}}
                            </div>
                            <div style="margin:5px 0px" class="bill-no" *ngIf="element.status == 'BILLED'">
                                <span>
                                    {{'CREATE_BILLS.bill_no' | translate}}: {{ element.bill_no }}
                                </span>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="amount">
                        <th mat-header-cell *matHeaderCellDef>
                            <!-- <div class="input">
                                <input type="text" placeholder="Bill Cycle">
                            </div> -->
                            {{'CREATE_BILLS.amount' | translate}} ({{currencySymbol}})
                        </th>
                        <td mat-cell *matCellDef="let element"> {{element.amount |numberFormat:element.amount}}</td>
                    </ng-container>
                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef>
                            <!-- <div class="input">
                                <input type="text" placeholder="Bill Cycle">
                            </div> -->
                            {{'CREATE_BILLS.actions' | translate}}
                        </th>
                        <td  mat-cell *matCellDef="let element">
                            <mat-icon class="more-icon" [matMenuTriggerFor]="actions" (click)="$event.stopPropagation()">more_horiz</mat-icon>
                            <mat-menu #actions="matMenu">
                                <button mat-menu-item *ngIf="element.status == 'DISAPPROVED'" (click)="regenerateInvoice(element)">{{'CREATE_BILLS.regenerate' | translate}}</button>
                                <button mat-menu-item  *ngIf="element.status == 'APPROVED'" [ngStyle]="{'color': selectedShipper.id == '' ? '#bbb': null, 'background-color': selectedShipper.id == '' ? '#e7e7e7': null}" [disabled]="selectedShipper.id == ''" (click)="generateModalType = 'generate';generateBill([element.id], element.shipperId)" >{{'CREATE_BILLS.generate' | translate}}</button>
                                <button mat-menu-item  (click)=" $event.stopPropagation(); openShipmentDetails(element)" >{{'CREATE_BILLS.view_shipment' | translate}}</button>
                                <button mat-menu-item (click)="$event.stopPropagation(); openInvoiceHistory(element)">{{'CREATE_BILLS.invoice_history' | translate}}</button>
                                <button mat-menu-item  *ngIf="element.status == 'PENDING'" (click)=" $event.stopPropagation(); openShipmentDetails(element, 6)" >{{'CREATE_BILLS.edit' | translate}}</button>

                                </mat-menu>
                        </td>
                        <!-- <td  mat-cell *matCellDef="let element"> <a class="invoice_text" href="{{element.invoice_link}}">{{element.invoice_pdf}}</a></td> -->
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayColumns;" (click)="row.expand = !row.expand" [ngStyle]="{'cursor': (row.allLocationsData.length > 2) ? 'pointer' : 'default'}" ></tr> 
                    <!-- (mouseleave)="row.expand = !row.expand" -->
                    
                </table>
                <mat-paginator [length]="(invoices.length) ? totalInvoices : 0" [pageSizeOptions]="[5, 10, 25, 50, 100]" showFirstLastButtons [pageSize]="25"
                    (page)="pageNavigate($event)" style="border-top: solid 1px #ededed; border-bottom: solid 1px #ededed;"></mat-paginator>
        </div>
        <ng-template #noInvoices>
        <div class="noInvoices">
                {{'CREATE_BILLS.no_invoices_found' | translate}}
        </div>
        </ng-template>
    </div>
</div>

<ng-template #generateBillModal>
    <div class="generateBillModal">
        <div class="header">
            <div class="text" *ngIf="generateModalType == 'bulk'">
              {{ 'CREATE_BILLS.bulk_generate_bill' | translate}}
            </div>
            <div class="text"  *ngIf="generateModalType == 'generate'">
              {{ 'CREATE_BILLS.generate' | translate}}
            </div>
            <div  class="text" *ngIf="generateModalType == 'regenerate'">
              {{ 'CREATE_BILLS.regenerate' | translate}}
            </div>
            <i class="material-icons" (click)="closeGenerateBillModal();">clear</i>
          </div>
          <div class="section">
            <h2 style="font-weight: normal;" *ngIf="generateModalType == 'bulk'"> {{ 'CREATE_BILLS.bulk_dialog_text' | translate}}</h2>
            <h2 style="font-weight: normal;" *ngIf="generateModalType == 'generate'"> {{ 'CREATE_BILLS.generate_dialog_text' | translate}}</h2>
            <h2 style="font-weight: normal;" *ngIf="generateModalType == 'regenerate'"> {{ 'CREATE_BILLS.regenerate_dialog_text' | translate}}</h2>
            <div class="submitButtonYes" (click)="createBill();" *ngIf="!spinner">
              <div class="button" style="background-color: #73235c;">
                {{'CONFIRMMODAL.yes' | translate}}
              </div>
            </div>
            <div style="display:inline-flex;" *ngIf="spinner">
                <span >
                  <mat-spinner [diameter]="20" style="position: relative;left:30px;top: 30px;"></mat-spinner>
                </span>
            </div>
            <div class="submitButtonNo" (click)="closeGenerateBillModal();" >
              <div class="button" style="background-color: #a0a0a0;">
                {{'CONFIRMMODAL.no' | translate}}
              </div>
            </div>
          </div>
    </div>
</ng-template>